<template>
    <div id="hd">
        <div class="wp">
            <div class="logo">
                <router-link to="/"><img src="../assets/images/logo.png" alt=""></router-link>
            </div>
            <div id="nav">
                <ul>
                    <li>
                        <router-link to="/">首页</router-link>
                    </li>
                    <li>
                        <router-link to="/product">产品服务</router-link>
                    </li>
                    <li>
                        <router-link to="/about">关于灵能</router-link>
                    </li>
                    <li>
                        <router-link to="/contact">联系我们</router-link>
                    </li>
                </ul>
            </div>
            <!--<div class="tel">18913911172</div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopNavBar"
    }
</script>

<style scoped>

</style>